import { useState } from "react";

import { useFusionService } from "@/hooks/machines/fusion";
import type { FusionServiceMachine } from "@/schemas/machine";

import { FusionServiceTemplate } from "./fusion-service.template";

export interface FusionServiceProps {
	readonly machine: FusionServiceMachine;
}

export const FusionService = ({ machine: initialMachine }: FusionServiceProps) => {
	const [machine, setMachine] = useState<FusionServiceMachine>(initialMachine);
	const fusionService = useFusionService();

	const handleToggleTrackRollerClicked = async (trackNumber: number) => {
		const isActive = machine.rollerTools?.includes(trackNumber) ?? false;

		await fusionService.toggleTrackRoller(machine.id, trackNumber, isActive);

		setMachine((currentMachine) => ({
			...currentMachine,
			rollerTools: isActive
				? (currentMachine.rollerTools ?? []).filter((number) => number !== trackNumber)
				: [...(currentMachine.rollerTools ?? []), trackNumber],
		}));
	};

	const handleFeedRollerForwardClicked = async () => {
		await fusionService.feedRollerForward(machine.id);
	};

	const handleToggleCrossHeadCutClicked = async () => {
		const isActive = machine.activeCrossHeadCut ?? false;

		await fusionService.toggleCrossHeadCut(machine.id, isActive);

		setMachine((currentMachine) => ({ ...currentMachine, activeCrossHeadCut: !isActive }));
	};

	const handleToggleCrossHeadLatchClicked = async () => {
		const isActive = machine.activeCrossHeadLatch ?? false;

		await fusionService.toggleCrossHeadLatch(machine.id, isActive);

		setMachine((currentMachine) => ({ ...currentMachine, activeCrossHeadLatch: !isActive }));
	};

	const handleCalibrateClicked = () => {
		return fusionService.calibrate(machine.id);
	};

	const handleCycleCrossHeadToolsClicked = () => {
		return fusionService.cycleCrossHeadTools(machine.id);
	};

	const handleCycleTrackToolsClicked = () => {
		return fusionService.cycleTrackTools(machine.id);
	};

	return (
		<FusionServiceTemplate
			machine={machine}
			onCalibrateClicked={handleCalibrateClicked}
			onCycleCrossHeadToolsClicked={handleCycleCrossHeadToolsClicked}
			onCycleTrackToolsClicked={handleCycleTrackToolsClicked}
			onToggleCrossHeadCutClicked={handleToggleCrossHeadCutClicked}
			onToggleCrossHeadLatchClicked={handleToggleCrossHeadLatchClicked}
			onToggleTrackRollerClicked={handleToggleTrackRollerClicked}
			onFeedRollerForwardClicked={handleFeedRollerForwardClicked}
		/>
	);
};
